export const STRENGTH_NONE = 'none';
export const STRENGTH_STRONG = 'strong';
export const STRENGTH_NORMAL = 'normal';
export const STRENGTH_WEAK = 'weak';
